import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { PatientService } from 'src/app/services/patient.service';
import { Printer, PrintService } from 'src/app/services/print.service';
import { PatientComponent } from '../patient/patient.component';

@Component({
  selector: 'app-patient-administrative',
  templateUrl: './patient-administrative.component.html',
  styleUrls: ['./patient-administrative.component.scss']
})
export class PatientAdministrativeComponent extends PatientComponent implements OnInit {

  constructor(private printSrv: PrintService) {
    super();
  }

  ngOnInit(): void {
  }

  set gdpr(checked: boolean) {
    this.patient.setProperty('gdpr', (checked) ? 'true' : 'false');
    this.patient.setProperty('gdpr-date', moment().local().format('DD/MM/YYYY'));
    this.patient.update().subscribe();
  }

  get gdpr() {
    return (this.patient.getProperty('gdpr') === 'true') ? true : false;
  }

  get gdprDate() {
    return (this.patient.getProperty('gdpr-date') !== null) ? this.patient.getProperty('gdpr-date') : '';
  }

  print(): void {
    const payload = {
      itemids: [
        {
          prefix: 'patient',
          ids: [this.patient.id],
          type: 'value',
        }
      ]
    };
    const pdfPrinter = new Printer();
    pdfPrinter.id = 'pdf';
    pdfPrinter.name = 'pdf';
    this.printSrv.printTemplate('gdpr', pdfPrinter, payload).subscribe(result => {
      // open document in other tab
      const documentLink = '/SN/StVaast/DocumentFile.php?doc=' + result;
      window.open(documentLink, '_blank');
    });
  }
}
